import React, { useMemo, useState } from 'react';
import { DetailsAccordion } from '../EquipmentDetails/StyledComponents';
import { PipesAndSpanTables } from './PipesAndSpanTables';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { PipesAndSpanTableType } from '@/types';
import { useGetAssemblyDataForInsightsQuery } from '@/__generated__/graphql';

type Props = { assemblyId: string | undefined; fieldKey: string };

export const PipesAndSpanComponents = ({ assemblyId, fieldKey }: Props) => {
  const [pipesCount, setPipesCount] = useState<number>(0);
  const assemblyTemplate = useAtomValue(state.assemblyTemplate);
  const templateField = useMemo(() => {
    return assemblyTemplate?.fields?.find((field) => field.key === fieldKey);
  }, [assemblyTemplate?.fields, fieldKey]);
  const { data: assemblyTablesData, loading } = useGetAssemblyDataForInsightsQuery({
    variables: { assemblyId },
    skip: !assemblyId,
    errorPolicy: 'all',
  });

  const PipesAndSpanTableData = useMemo(() => {
    const templateFieldData = assemblyTablesData?.assembly?.templateFieldData ?? {};
    return (templateFieldData[fieldKey] ?? {}) as PipesAndSpanTableType;
  }, [assemblyTablesData?.assembly?.templateFieldData, fieldKey]);

  if (templateField && PipesAndSpanTableData && Object.keys(PipesAndSpanTableData).length > 0) {
    return (
      <DetailsAccordion title={templateField.name} subTitle={pipesCount || ''}>
        <PipesAndSpanTables
          pipesAndSpanData={PipesAndSpanTableData}
          loading={loading}
          metaData={templateField.metaData}
          setAssociatedPipingCount={setPipesCount}
        />
      </DetailsAccordion>
    );
  }
  return <></>;
};
